import { FC, useState } from 'react';

import { usePage } from '@inertiajs/react';
import { ArrowRight, CircleDollarSign } from 'lucide-react';

import { ServiceFeeDetailsDialog } from './ServiceFeeDetailsDialog';
import {
    formatServiceFeeDate,
    formatServiceFeeMoney,
    formatServiceFeeShortDate,
    ServiceFeePageProps,
} from './serviceFeePresentation';
import { Button } from '../ui/Button';

export const ServiceFeeAnnouncement: FC = () => {
    const { serviceFeeAnnouncement } = usePage<ServiceFeePageProps>().props;
    const [detailsOpen, setDetailsOpen] = useState(false);

    if (!serviceFeeAnnouncement?.visible) return null;

    const { startsOn, thresholdCents, percentage, maxCents } =
        serviceFeeAnnouncement;
    const startDate = formatServiceFeeDate(startsOn);
    const shortStartDate = formatServiceFeeShortDate(startsOn);
    const threshold = formatServiceFeeMoney(thresholdCents);
    const maximumFee = formatServiceFeeMoney(maxCents);

    return (
        <>
            <aside className="mt-6 rounded-2xl border border-primary/30 bg-primary/5 p-4 sm:flex sm:items-center sm:justify-between sm:gap-6 sm:px-5">
                <div className="flex min-w-0 items-start gap-3">
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                        <CircleDollarSign className="h-5 w-5" />
                    </div>
                    <div>
                        <h2 className="font-semibold">
                            Увага - з {shortStartDate} діятиме сервісний збір
                        </h2>
                        <p className="mt-1 text-sm leading-relaxed text-muted-foreground">
                            {percentage}% із завершених продажів більше{' '}
                            {threshold} — максимум {maximumFee} за замовлення.
                        </p>
                    </div>
                </div>
                <Button
                    type="button"
                    variant="outline"
                    className="mt-4 w-full shrink-0 bg-background sm:mt-0 sm:w-auto"
                    onClick={() => setDetailsOpen(true)}
                >
                    Детальніше
                    <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
            </aside>

            <ServiceFeeDetailsDialog
                open={detailsOpen}
                onOpenChange={setDetailsOpen}
                startDate={startDate}
                threshold={threshold}
                percentage={percentage}
                maximumFee={maximumFee}
            />
        </>
    );
};
